import Column from 'components/Column'
import iconColor from 'components/iconColor'
import Text from 'components/Text'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import * as React from 'react'
import styled from 'styled-components'
import { color, px, screenWidth } from 'utils'

type PropsType = {
  children?: React.ReactNode
  className?: string
  current?: number
  icon?: React.ComponentType<any>
  sub?: React.ReactNode
  theme?: 'dark' | 'light'
  title?: React.ReactNode
  total?: number
}

type BarPropsType = {
  width: number
}

const getBorderRadius = (props: BarPropsType) => (props.width === 100 ? '3px 3px 0 0' : '3px 0 0 0')

const Bar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 0.25rem;
  width: ${({ width }: BarPropsType) => `${width}%`};
  background: ${color('blue600')};
  border-radius: ${getBorderRadius};
`

const Wrapper = styled(Column)`
  position: relative;
  width: 100%;
  padding: 2rem;
  flex-flow: wrap;

  > * {
    flex: 1 0 100%;
  }

  @media only screen and (max-width: ${screenWidth('sm')}) {
    padding: 1.5rem;
  }
`

const TitleWrapper = styled(Column)`
  position: relative;
  width: 100%;
`

const Title = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  text-align: center;
`

const SubWrapper = styled.div<PropsType>`
  display: flex;
  margin: ${({ icon }) => (isNil(icon) ? '0 1.75rem' : 'auto')};
  margin-bottom: 2.75rem;
  text-align: ${({ icon }) => (isNil(icon) ? 'center' : 'left')};

  @media only screen and (max-width: ${screenWidth('xs')}) {
    margin: ${({ icon }) => (isNil(icon) ? '0 0.5rem' : 'auto')};
    margin-bottom: 2.75rem;
  }
`

const IconWrapper = styled.div<{ sub: any }>`
  ${iconColor('dark200')};
  ${({ sub }: PropsType) => (isEmpty(sub) ? '' : 'margin-right: 1.5rem')};

  svg {
    ${iconColor('dark200')};
  }
`

const Container = ({
  children,
  className,
  current,
  icon,
  sub,
  theme = 'light',
  title,
  total
}: PropsType) => {
  const Icon = icon

  return (
    <Wrapper className={className || ''} justifyContent='stretch'>
      {!isNil(current) && !isNil(total) && <Bar width={(current / total) * 100} />}

      <TitleWrapper alignItems='center' justifyContent='center' shrink={0}>
        {!isNil(title) && (
          <Title color={theme === 'light' ? 'black' : 'white'} size='xl' weight={600}>
            {title}
          </Title>
        )}

        {!isNil(sub) && (
          <SubWrapper icon={icon}>
            {!isNil(Icon) && (
              <IconWrapper sub={sub}>
                <Icon size={px(2.5)} />
              </IconWrapper>
            )}
            <Text color='dark300'>{sub}</Text>
          </SubWrapper>
        )}
      </TitleWrapper>

      {children}
    </Wrapper>
  )
}

export default Container
